import React from 'react';
import Link from 'components/misc/Link';
import { getSeedlyEventTitle } from 'entity/group/groupUtils';
import { Group } from 'entity/group/groupRedux';

interface OwnProps {
  group: Group;
  onEpisodeClick: () => void;
  seedlyEventTopics: {
    id: number;
    slug: string;
    name: string;
  }[];
}

const EpisodeCard = (props: OwnProps) => {
  const { seedlyEventTopics, group, onEpisodeClick } = props;

  return (
    <div className="card">
      <div className="flex flex-col gap-4">
        <p className="text-base font-bold">{`All ${
          group.name
        } ${getSeedlyEventTitle(group.slug)}`}</p>
        <ul className="pl-8">
          {seedlyEventTopics.map(topic => {
            return (
              <Link
                key={topic.id}
                href={`/community/${group.slug}?filter=${topic.slug}`}
              >
                <li className="text-blue-500 cursor-pointer hover:underline list-disc">
                  <span onClick={onEpisodeClick}>{topic.name}</span>
                </li>
              </Link>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default EpisodeCard;
